import type { FC, SVGProps } from 'react';

export const ChartIcon: FC<SVGProps<SVGSVGElement>> = (props) => {
  return (
    <svg
      width="14"
      height="14"
      fill="currentColor"
      viewBox="0 0 14 14"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <g clipPath="url(#clip0_2002_5766)">
        <rect width="14" height="14" fillOpacity="0.01" fill="currentColor" />
        <path
          fill="currentColor"
          d="M1.99963 1.50098C2.06838 1.50098 2.12463 1.55723 2.12463 1.62598V11.376H12.8746C12.9434 11.376 12.9996 11.4322 12.9996 11.501V12.376C12.9995 12.4446 12.9433 12.501 12.8746 12.501H1.12463C1.05605 12.5009 0.999815 12.4445 0.999634 12.376V1.62598C0.999634 1.55727 1.05594 1.50105 1.12463 1.50098H1.99963ZM4.37463 7.62598C4.44338 7.62598 4.49963 7.68223 4.49963 7.75098V10.001C4.49945 10.0696 4.44327 10.126 4.37463 10.126H3.49963C3.43105 10.1259 3.37482 10.0695 3.37463 10.001V7.75098C3.37463 7.68227 3.43094 7.62605 3.49963 7.62598H4.37463ZM6.74963 4.87598C6.81838 4.87598 6.87463 4.93223 6.87463 5.00098V10.001C6.87445 10.0696 6.81827 10.126 6.74963 10.126H5.87463C5.80605 10.1259 5.74982 10.0695 5.74963 10.001V5.00098C5.74963 4.93227 5.80594 4.87605 5.87463 4.87598H6.74963ZM9.12463 6.09473C9.19338 6.09473 9.24963 6.15098 9.24963 6.21973V10.001C9.24945 10.0696 9.19327 10.126 9.12463 10.126H8.24963C8.18105 10.1259 8.12482 10.0695 8.12463 10.001V6.21973C8.12463 6.15102 8.18094 6.0948 8.24963 6.09473H9.12463ZM11.4996 3.62598C11.5684 3.62598 11.6246 3.68223 11.6246 3.75098V10.001C11.6245 10.0696 11.5683 10.126 11.4996 10.126H10.6246C10.5561 10.1259 10.4998 10.0695 10.4996 10.001V3.75098C10.4996 3.68227 10.5559 3.62605 10.6246 3.62598H11.4996Z"
        />
      </g>
      <defs>
        <clipPath id="clip0_2002_5766">
          <rect width="14" height="14" fill="currentColor" />
        </clipPath>
      </defs>
    </svg>
  );
};
